var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M58.5,31.5h-57C0.7,31.5,0,30.8,0,30s0.7-1.5,1.5-1.5h57c0.8,0,1.5,0.7,1.5,1.5S59.3,31.5,58.5,31.5z","key":0}),React.createElement("path",{"d":"M30,60c-0.8,0-1.5-0.7-1.5-1.5v-57C28.5,0.7,29.2,0,30,0s1.5,0.7,1.5,1.5v57C31.5,59.3,30.8,60,30,60z","key":1})]);
}

Plus.defaultProps = {"baseProfile":"tiny","viewBox":"0 0 60 60","overflow":"visible"};

module.exports = Plus;

Plus.default = Plus;
